/**
* Project janux-vuejs-seed
* Created by hielo on 2019-03-11
*/

<template lang="pug">
div
	<!--p.form-section-->
		<!--| {{ componentTitle }}-->
	<!--fieldset.fieldset-flex-->
		<!--.fieldset-flex-->
			<!--.an-material.nopadding-->
				<!--md-field.full-->
					<!--// label Company Name-->
					<!--.field-title(v-if="data.name") Company Name-->
					<!--md-input(v-model='data.name', required="", @input="validate")-->
		<!--.error-val(v-if="!data.name") Enter a valid company name-->

	fieldset
		.field-title(v-if="data.name") Company Name
		.error-val.error-contact(v-if="!data.name") Enter the company name
		.each-field-contact: b-form-input.all-fields(placeholder='Company Name' v-model='data.name', required="", @input="validate", :class="{ errorInField: !data.name }")

	slot(:person-name-valid="isValid")
</template>

<script>
export default {
	name: 'jnx-org-name',
	props: ['sectionTitle', 'data', 'isValid'],
	methods: {
		validate () {
			this.isValid.name = !!(this.data.name)
			let iterate = true
			Object.keys(this.isValid).forEach(key => {
				if (key !== 'result') {
					if (!this.isValid[key] && iterate) {
						iterate = false
						this.isValid.result = false
					} else if (this.isValid[key] && iterate) {
						this.isValid.result = true
					}
				}
			})
		}
	},
	beforeMount () {
		this.validate()
	},
	computed: {
		componentTitle () {
			return this.$t(this.sectionTitle)
		}
	}
}
</script>



// WEBPACK FOOTER //
// ../../easytitle24-2.x-common/components/party/org-name.vue